/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadCommentCount
 */
export interface LeadCommentCount {
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    comment_count: number;
}

/**
 * Check if a given object implements the LeadCommentCount interface.
 */
export function instanceOfLeadCommentCount(value: object): value is LeadCommentCount {
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('comment_count' in value) || value['comment_count'] === undefined) return false;
    return true;
}

export function LeadCommentCountFromJSON(json: any): LeadCommentCount {
    return LeadCommentCountFromJSONTyped(json, false);
}

export function LeadCommentCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadCommentCount {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'],
        'comment_count': json['comment_count'],
    };
}

export function LeadCommentCountToJSON(json: any): LeadCommentCount {
    return LeadCommentCountToJSONTyped(json, false);
}

export function LeadCommentCountToJSONTyped(value?: LeadCommentCount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'comment_count': value['comment_count'],
    };
}

